export enum MimeType {
  XLSX = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  CSV = 'text/csv',
  JSON = 'application/json',
  PDF = 'application/pdf',
  KMZ = 'application/vnd.google-earth.kmz',
  SHAPE = 'application/x-zip',
  APNG = 'image/apng',
  GIF = 'image/gif',
  MP4 = 'video/mp4',
  TIFF = 'image/tiff',
  JPG = 'image/jpeg',
  DOCX = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
}
